// Alias
import Radio from '../radio/index';

export default Radio;
